import { getDataWithPromise, handleAjaxError } from "./BaseDataFns";

export const getOrgBreachStats = (owner_id, onCompleteFunc) => {
    
          const url = Globals.APIFolder +  '/gdpr/breaches/owner/' + owner_id + '/stistics';
    
          getDataWithPromise(url, 'GET', {}).then(data =>
              {
                onCompleteFunc ( data );
      })
          .catch((jqXHR, textStatus, error) =>
              {
                handleAjaxError(jqXHR, textStatus, error);
          });
    
          return ;
    };

export const getOrgAdvice = (owner_id, onCompleteFunc) => {

    const url = Globals.APIFolder +  '/gdpr/breaches/owner/' + owner_id + '/advice';

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });

    return ;
};

export const getSchoolLunchReport = (formData, onComplete, onError) =>
{
    return $.ajax({
        type: 'post',
        url: 'ajaxSchoolLunchRep.php',
        data: formData,
        success: function (data)
        {
            console.log(data)
            try
            {
                var ReturnedData = $.parseJSON(data);// Parse the returned results
                var results = ReturnedData.results;// Pull out the 'results' node
                var err = results.error;

                if(err.indexOf('.pdf') != -1)
                {
                    onComplete(results);
                }
                else
                {
                    onError(data, err)
                }
            }
            catch(error)
            {
                onError(data, error.message)
            }
        },
        error: function (data)
        {
            onError(data, data.responseText)
        }
    })
}